import { render, staticRenderFns } from "./IndividualAllowances.vue?vue&type=template&id=6d285a9d&"
import script from "./IndividualAllowances.vue?vue&type=script&lang=js&"
export * from "./IndividualAllowances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports